import React from "react";
import styles from "./BigGalleryCard.module.scss";
import galleryImage from "../../../assets/images/gallery-image.jpg";
import { useNavigate } from "react-router-dom";

const BigGalleryCard = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.card} onClick={() => navigate("/galleries/1")}>
      <h2 className={styles.title}>Name Of The Gallery</h2>
      <div className={styles.grid}>
        <div className={styles.image}>
          <img src={galleryImage} alt="Name Of The Gallery" />
        </div>
        <div className={styles.info}>
          <div className={styles.about}>
            <div className={styles.title}>About the gallery</div>
            <div className={styles.description}>
              Contrary to popular belief, Lorem Ipsum is not simply random text.
              It has roots in a piece of classical Latin literature from 45 BC.{" "}
            </div>
          </div>
          <div className={styles.artists}>
            <div className={styles.title}>Artists</div>
            <div className={styles.description}>
              Contrary to popular belief, Lorem Ipsum is not simply random text.
              It has roots in a piece of classical Latin literature from 45 BC.{" "}
            </div>
          </div>
          <div className={styles.upcomingExhibitions}>
            <div className={styles.title}>Upcoming exhibitions</div>
            <div className={styles.description}>
              Contrary to popular belief, Lorem Ipsum is not simply random text.
              It has roots in a piece of classical Latin literature from 45 BC.{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BigGalleryCard;
